import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styled';

const ArticlePreview = ({ metaTitle, metaDescription, canonical }) => {
  return (
    <Styled.Preview href={canonical}>
      <Styled.Card>
        <Styled.Title>{metaTitle}</Styled.Title>
        <Styled.Description style={{ color: '#1B314B' }}>{metaDescription}</Styled.Description>
      </Styled.Card>
    </Styled.Preview>
  );
};

export default ArticlePreview;

ArticlePreview.propTypes = {
  metaTitle: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
  canonical: PropTypes.string.isRequired,
};
